import { getCard, getDeckCode } from '../../shared/index.js';
import { cardEqual, suitEqual, } from '../../shared/deck/Deck.js';
import { getLedSuit } from '../state/trick.js';
export var ExpertIds;
(function (ExpertIds) {
    ExpertIds["thirsty"] = "thirsty";
    ExpertIds["cautious"] = "cautious";
    ExpertIds["random"] = "random";
})(ExpertIds || (ExpertIds = {}));
export function ensureIsPlayersTurn(state) {
    if (state.playerId !== state.currentRound?.turnPlayerId) {
        throw new Error('attempted to take action for non turn player');
    }
}
export function getSuitFollowingCards(param, trickState) {
    const deckCode = getDeckCode(param);
    const ledSuit = getLedSuit(deckCode, trickState.trick);
    const followingCards = trickState.handCards.filter((card) => suitEqual(card.suit, ledSuit));
    return followingCards.length ? followingCards : undefined;
}
function getWinnerOfTwoCards(param, cardRef1, cardRef2, trump, ledSuit) {
    const card1 = getCard(param, cardRef1);
    const card2 = getCard(param, cardRef2);
    if (suitEqual(card1.suit, card2.suit)) {
        return getCardOfHigherValue(param, cardRef1, cardRef2);
    }
    if (suitEqual(card1.suit, trump)) {
        return cardRef1;
    }
    if (suitEqual(card2.suit, trump)) {
        return cardRef2;
    }
    if (suitEqual(card1.suit, ledSuit)) {
        return cardRef1;
    }
    if (suitEqual(card2.suit, ledSuit)) {
        return cardRef2;
    }
    return cardRef1;
}
function getCardOfHigherValue(param, cardRef1, cardRef2) {
    const card1 = getCard(param, cardRef1);
    const card2 = getCard(param, cardRef2);
    if (!suitEqual(card1.suit, card2.suit)) {
        throw new Error('cards must be same suit');
    }
    return card1.cardValue > card2.cardValue ? cardRef1 : cardRef2;
}
export function getWinnerCardSoFar(param, trickState) {
    if (!trickState.trick.cards.length) {
        return undefined;
    }
    const ledSuit = getLedSuit(param, trickState.trick);
    if (!ledSuit) {
        return undefined;
    }
    return trickState.trick.cards.reduce((winningCard, nextCard) => {
        if (!winningCard) {
            return nextCard;
        }
        const winnerCardValue = getWinnerOfTwoCards(param, winningCard.card, nextCard.card, trickState.trumpSuit, ledSuit);
        return cardEqual(getCard(param, winnerCardValue), getCard(param, nextCard.card))
            ? nextCard
            : winningCard;
    }, undefined);
}
export function getBestLeadCard(trickState) {
    throw new Error('not implemented');
}
export function getLowestLeadCard(trickState) {
    throw new Error('not implemented');
}
// export function getWinningCards(trickState: TrickState): Card {
//   const winnerCard = getWinnerCardSoFar(trickState)
//   if (mustFollowSuit(trickState)) {
//     const winningCard = trickState.cards.filter(card => card.suit
//     )
//   }
// }
export function getLosingCards(trickState) {
    throw new Error('not implemented');
}
export function getLeastWinningCard(trickState) {
    throw new Error('not implemented');
}
export function getLeastLosingCard(trickState) {
    throw new Error('not implemented');
}
export function getMaxWinningCard(trickState) {
    throw new Error('not implemented');
}
export function getMaxLosingCard(trickState) {
    throw new Error('not implemented');
}
//# sourceMappingURL=shared.js.map